import { render, staticRenderFns } from "./PurchaseProcedure.vue?vue&type=template&id=6db0fd7f&scoped=true&"
import script from "./PurchaseProcedure.vue?vue&type=script&lang=js&"
export * from "./PurchaseProcedure.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseProcedure.vue?vue&type=style&index=0&id=6db0fd7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0fd7f",
  null
  
)

export default component.exports